'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PayPalPaymentField = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PayPalPaymentField, _React$Component);

  function PayPalPaymentField() {
    (0, _classCallCheck3.default)(this, PayPalPaymentField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PayPalPaymentField.__proto__ || (0, _getPrototypeOf2.default)(PayPalPaymentField)).call(this));

    _this.state = {
      loaded: false
    };
    return _this;
  }

  (0, _createClass3.default)(PayPalPaymentField, [{
    key: 'onPaymentMethodNonceReceived',
    value: function onPaymentMethodNonceReceived(_ref) {
      var details = _ref.details,
          nonce = _ref.nonce;
      var onPaymentMethodNonceAndDeviceDataReceived = this.props.onPaymentMethodNonceAndDeviceDataReceived;
      var deviceData = this.state.deviceData;


      this.setState({
        paypalDetails: details
      });

      onPaymentMethodNonceAndDeviceDataReceived(details.email, nonce, deviceData);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var braintree = require('braintree-web');
      var _props = this.props,
          clientToken = _props.clientToken.value,
          behavior = _props.behavior;


      braintree.setup(clientToken, 'custom', {
        paypal: {
          headless: true,
          singleUse: behavior === 'oneoff'
        },
        dataCollector: {
          paypal: true
        },
        onReady: function onReady(braintreeInstance) {
          _this2.braintreeInstance = braintreeInstance;

          _this2.setState({
            loaded: true,
            deviceData: braintreeInstance.deviceData
          });
        },
        onPaymentMethodReceived: this.onPaymentMethodNonceReceived.bind(this)
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      this.braintreeInstance.teardown(function () {
        _this3.braintreeInstance = null;
      });
    }
  }, {
    key: 'onContinuePaymentClick',
    value: function onContinuePaymentClick(ev) {
      ev.preventDefault();

      this.braintreeInstance.paypal.initAuthFlow();
    }
  }, {
    key: 'onChangePayPalClick',
    value: function onChangePayPalClick(ev) {
      ev.preventDefault();

      var onPaymentMethodNonceAndDeviceDataReceived = this.props.onPaymentMethodNonceAndDeviceDataReceived;


      this.setState({ paypalDetails: null });

      onPaymentMethodNonceAndDeviceDataReceived(null, null, null);
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./PayPalPaymentField.scss');
      var _state = this.state,
          paypalDetails = _state.paypalDetails,
          loaded = _state.loaded;


      return _react2.default.createElement(
        'div',
        { className: styles.PayPalPaymentField },
        !loaded ? _react2.default.createElement(_components.LoadingIndicator, { className: styles.PayPalPaymentField__loadingIndicator }) : paypalDetails ? _react2.default.createElement(
          'div',
          { className: styles.PayPalPaymentField__detailsBox },
          _react2.default.createElement(
            'span',
            { className: styles.PayPalPaymentField__detailsLabel },
            'You will be paying with:'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.PayPalPaymentField__email },
            paypalDetails.email,
            _react2.default.createElement(
              'span',
              {
                className: styles.PayPalPaymentField__cancelButton,
                onClick: this.onChangePayPalClick.bind(this) },
              'Change PayPal account...'
            )
          )
        ) : _react2.default.createElement(
          'div',
          { className: styles.PayPalPaymentField__initBox },
          _react2.default.createElement(
            'span',
            { className: styles.PayPalPaymentField__initInfo },
            'You will be redirected to PayPal to complete your purchase.'
          ),
          _react2.default.createElement(
            'span',
            { className: styles.PayPalPaymentField__initButton },
            _react2.default.createElement('img', { src: '/icons/pay-with-paypal.png',
              onClick: this.onContinuePaymentClick.bind(this) })
          )
        )
      );
    }
  }]);
  return PayPalPaymentField;
}(_react2.default.Component), _class.propTypes = {
  clientToken: _react2.default.PropTypes.string.isRequired,
  behavior: _react2.default.PropTypes.oneOf(['subscription', 'oneoff']).isRequired,
  onPaymentMethodNonceReceived: _react2.default.PropTypes.func
}, _temp);
exports.default = PayPalPaymentField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PayPalPaymentField/PayPalPaymentField.jsx
// module id = 2674
// module chunks = 0